import React, { Component } from "react";
import ModalPopupComponent from "../../ModalPopupComponent/theme12/ModalPopupComponent";
import { managebooking } from "../../../lib/managebooking";
import { emailReg, alphanumericSpecialChars } from "../../../lib/utils/regex_cheat_sheet";
import Verification from "../../../components/login/Theme12/Registration/verification";
import EmailStep from "@/commonComponents/ManageBooking/theme12/emailStep";
import { otpMobileSign, otpMobileVerify, otpMobileResend } from "../../../lib/otpsignin";

class ManageBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailIDError: false,
      emailIDErrorRecheck: false,
      isData: false,

      showVerification: false,
      loading: false,

      otp: [],
      otpLength: 4,
      otpExpired: false,
      otpError: "",
      customer_id: "",

      timer: 0,
      isPartialRegister: false
    };

    this.timerInterval = null;
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  /* ---------------- TIMER ---------------- */

  startTimer = (ms = 0) => {
    this.clearTimer();
    if (!ms) return;

    this.setState({ timer: ms, otpExpired: false });

    this.timerInterval = setInterval(() => {
      this.setState((prev) => {
        if (prev.timer <= 1000) {
          this.clearTimer();
          return { timer: 0, otpExpired: true };
        }
        return { timer: prev.timer - 1000 };
      });
    }, 1000);
  };

  clearTimer = () => {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  };

  formatTimer = (ms) => {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  /* ---------------- EMAIL ---------------- */

  handleEmailChange = (e) => {
    const value = e.target.value;
    if (alphanumericSpecialChars.test(value) || value === "") {
      this.setState({
        email: value,
        emailIDError: false,
        emailIDErrorRecheck: false,
        isData: false
      });
    }
  };

  validateEmail = () => {
    const { email } = this.state;
    const emailIDError = !email;
    const emailIDErrorRecheck = email && !emailReg.test(email);

    this.setState({ emailIDError, emailIDErrorRecheck });
    return !emailIDError && !emailIDErrorRecheck;
  };

  goBackToEmailStep = () => {
    this.clearTimer();
    this.setState({
      showVerification: false,
      otp: [],
      otpError: "",
      otpExpired: false,
      timer: 0,
      loading: false
    });
  };


  onClosePopup = () => {
    this.clearTimer();
    this.resetState();
    this.props.data?.handleManageBooking(false);
  };
  resetState = () => {
    this.setState({
      email: "",
      emailIDError: false,
      emailIDErrorRecheck: false,
      isData: false,
      btnClicked: false,
      showVerification: false,
      isVerifying: false,
      timer: 90000,
      otp: [],
      otpExpired: false,
    });
  };
  /* ---------------- SEND OTP ---------------- */

  handleSendOTP = async (type) => {
    if (!this.validateEmail()) return;

    this.setState({ loading: true });

    try {
      const response = await otpMobileSign({
        email: this.state.email,
        type
      });

      if (response?.status) {
        const otpLength = response?.data?.otp_length || 4;
        const expiry = response?.data?.resend_timer || 90000;

        this.setState({
          showVerification: true,
          loading: false,
          otpLength,
          otp: Array(otpLength).fill(""),
          otpError: "",
          customer_id: response?.data?._id,
          isPartialRegister: response?.data?.isPartialRegister
        });

        this.startTimer(expiry);
      } else {
        this.setState({ isData: true, loading: false });
      }
    } catch (err) {
      console.error("Send OTP error:", err);
      this.setState({ isData: true, loading: false });
    }
  };

  /* ---------------- OTP INPUT ---------------- */
  handleOtpChange = (index, value) => {
    if (index === null || index === undefined) {
      if (Array.isArray(value)) {
        this.setState({ otp: value, otpError: "" });
      }
      return;
    }

    const otp = Array.from(this.state.otp);
    if (otp.length < this.state.otpLength) {
      otp.length = this.state.otpLength;
      for (let i = 0; i < this.state.otpLength; i++) {
        if (otp[i] === undefined) otp[i] = "";
      }
    }
    if (index < 0 || index >= this.state.otpLength) return;

    otp[index] = value;
    this.setState({ otp, otpError: "" });
  };

  /* ---------------- VERIFY OTP ---------------- */

  onOtpVerify = async () => {
    if (this.state.otpExpired) return;

    const otpValue = this.state.otp.join("");
    this.setState({ loading: true });

    try {
      const response = await otpMobileVerify({
        email: this.state.email,
        otp: otpValue,
        customer_id: this.state.customer_id
      });

      if (response?.status) {
        if (response?.data?.is_registered) {
          window.location.href = "/myprofile?activeTab=transactions";
        } else {
          window.location.href = "/mybookings";
        }
      } else {
        this.setState({
          otpError: "Invalid OTP. Please try again.",
          loading: false,
          otp: Array(this.state.otpLength).fill("")
        });
      }
    } catch (err) {
      console.error("Verify OTP error:", err);
      this.setState({ loading: false });
    }
  };

  /* ---------------- RESEND OTP ---------------- */

  onResendOtp = async (type) => {
    try {
      const response = await otpMobileResend({
        email: this.state.email,
        type
      });

      if (response?.status) {
        const expiry = response?.data?.resend_timer || 90000;
        const otpLength = response?.data?.otp_length || this.state.otpLength;

        this.setState({
          otp: Array(otpLength).fill(""),
          otpLength,
          otpExpired: false,
          otpError: "",
          customer_id: response?.data?._id,
        });

        this.startTimer(expiry);
      }
    } catch (err) {
      console.error("Resend OTP error:", err);
    }
  };

  /* ---------------- UI ---------------- */

  renderEmailStep = () => (
    <EmailStep
      data={this.props.data}
      email={this.state.email}
      emailIDError={this.state.emailIDError}
      emailIDErrorRecheck={this.state.emailIDErrorRecheck}
      isData={this.state.isData}
      btnClicked={this.state.loading}
      onEmailChange={this.handleEmailChange}
      onSubmit={this.handleSendOTP}
      onClosePopup={this.onClosePopup}
    />
  );

  renderVerificationStep = () => (
    <Verification
      email={this.state.email}
      otp={this.state.otp}
      otpLength={this.state.otpLength}
      timer={this.formatTimer(this.state.timer)}
      otpExpired={this.state.otpExpired}
      otpError={this.state.otpError}
      loading={this.state.loading}
      styles={this.props.data.verifyCss}

      handleInputChange={this.handleOtpChange}
      onOtpSend={this.onOtpVerify}
      resendOtp={() => this.onResendOtp("resend_otp")}
      handleChangeStep={() => this.setState({ showVerification: false })}

    />
  );

  render() {
    const styles = this.props.data?.styles;

    return (
      <div className={styles.manageBooking_modal_container}>
        <ModalPopupComponent
          isMobile={this.props.data.isMobile}
          isPopup={this.props.data.manageBokingPopup}
          modalCss={this.props.data.modalCss}
          showCrossButton={!this.props.data.isMobile}
          onClosePopup={this.onClosePopup}
          showBackButton={this.props.data.isMobile ? true : false}
          onBackPopup={() => {
            this.state.showVerification
              ? this.goBackToEmailStep()
              : this.onClosePopup();
          }}

        >
          {this.state.showVerification
            ? this.renderVerificationStep()
            : this.renderEmailStep()}
        </ModalPopupComponent>
      </div>
    );
  }
}

export default ManageBooking;
